/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Card_On_FileInputs */

const en_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No card on file`)
};

const fr_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune carte enregistrée`)
};

const de_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Karte hinterlegt`)
};

const it_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna carta in archivio`)
};

const ru_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта не сохранена.`)
};

const es_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ninguna tarjeta en el archivo`)
};

const zh_cn2_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未登记银行卡`)
};

const ja_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カードが登録されていません`)
};

const hi_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई कार्ड रिकॉर्ड में नहीं है`)
};

const pt_pt2_no_card_on_file = /** @type {(inputs: No_Card_On_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum cartão cadastrado`)
};

/**
* | output |
* | --- |
* | "No card on file" |
*
* @param {No_Card_On_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_card_on_file = /** @type {((inputs?: No_Card_On_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Card_On_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_card_on_file(inputs)
	if (locale === "de") return de_no_card_on_file(inputs)
	if (locale === "it") return it_no_card_on_file(inputs)
	if (locale === "ru") return ru_no_card_on_file(inputs)
	if (locale === "es") return es_no_card_on_file(inputs)
	if (locale === "zh-CN") return zh_cn2_no_card_on_file(inputs)
	if (locale === "ja") return ja_no_card_on_file(inputs)
	if (locale === "hi") return hi_no_card_on_file(inputs)
	if (locale === "pt-PT") return pt_pt2_no_card_on_file(inputs)
	return en_no_card_on_file(inputs)
});